import SectionTitle from "./SectionTitle";

const supportPoints = [
  { icon: "ri-customer-service-2-line", title: "24/7 Live Chat", body: "Connect with a support agent at any time, day or night. The Ace96au team answered players at 3AM instantly — friendly, fast, and always available. Accessible directly on the website." },
  { icon: "ri-whatsapp-line", title: "WhatsApp Support", body: "Join the official WhatsApp group for quick updates, promotions, and direct support. Fast and convenient for Australian players on the go. Group link: chat.whatsapp.com/D35UAGXMv0gCG1HIlDvVwi" },
  { icon: "ri-telegram-line", title: "Telegram Channel", body: "Follow the official Telegram channel (t.me/ace96au_bot) for real-time announcements, bonus alerts, and community updates from the Ace96au team." },
  { icon: "ri-facebook-circle-line", title: "Facebook Community", body: "Join the Ace96au Facebook page (facebook.com/ACE96online) for the latest news, promotions, and player community discussions. Stay connected with thousands of members." },
  { icon: "ri-links-line", title: "Official Domains & Links", body: "Access all official Ace96au domains and verified links through heylink.me/ace96au to ensure you're always on the authentic platform. Never use unofficial links." },
  { icon: "ri-team-line", title: "Affiliate Partnership", body: "Earn commissions by joining the Ace96au affiliate program at auspartnership.net. Weekly commission 6% on all referred player activity. Contact Live Chat for details." },
];

export default function CustomerSupport() {
  return (
    <section id="customer" className="py-12">
      <SectionTitle>Customer Support</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        At Ace96au, help is always just a tap away. Whether you're a new player or a seasoned high roller, the support team is available 24/7 via live chat, WhatsApp, Telegram, and Facebook. Fast, friendly, and genuinely helpful — every question gets a real answer.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {supportPoints.map((p, i) => (
          <div key={i} className="glass-card rounded-2xl p-5 flex items-start gap-3 transition-all duration-300 hover:scale-[1.01] cursor-default">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{
                background: "linear-gradient(135deg, rgba(16,92,232,0.2), rgba(16,92,232,0.1))",
                border: "1px solid rgba(16,92,232,0.25)",
              }}
            >
              <i className={`${p.icon} text-lg`} style={{ color: "#105CE8" }}></i>
            </div>
            <div>
              <strong className="text-white text-sm font-semibold block mb-1">{p.title}</strong>
              <p className="text-slate-400 text-xs leading-relaxed">{p.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
